import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import Camera from '@/assets/svgs/permission/camera.svg';
import ImgPicker from '@/assets/svgs/permission/img-picker.svg';
import Notification from '@/assets/svgs/permission/notification.svg';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import type { DeviceTokenData } from '@/stores/DeviceStore';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { getAppStoreUrls } from '@/utils/appDownload';
import { useHandleApp } from '../_hooks/useHandleApp';
import { MESSAGE_KEYWORD } from '../_utils/reserved-keywords';
export const AppModal = () => {
  const $ = _c(46);
  const [appModal, setAppModal, setTempDeviceTokenData, osType] = useDeviceInfoStore(useShallow(_temp));
  const {
    isOpened,
    type
  } = appModal;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: MESSAGE_KEYWORD.EXIT_APP
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    request: requestExit
  } = useHandleApp(t0);
  let t1;
  if ($[1] !== setAppModal || $[2] !== type) {
    t1 = () => setAppModal({
      type,
      isOpened: false
    });
    $[1] = setAppModal;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const closeModal = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      type: MESSAGE_KEYWORD.NOTIFICATION
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    request: requestNotification,
    response: notificationResponse
  } = useHandleApp(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      type: MESSAGE_KEYWORD.SYSTEM_SETTINGS
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    request: requestSystemSettings
  } = useHandleApp(t3);
  const [isSwiftPending, setIsSwiftPending] = useState(false);
  const [needsSettings, setNeedsSettings] = useState(false);
  let t4;
  let t5;
  if ($[6] !== isSwiftPending || $[7] !== requestNotification) {
    t4 = () => {
      if (!isSwiftPending) {
        return;
      }
      if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
        const id = setTimeout(requestNotification, 5000);
        return () => clearTimeout(id);
      }
    };
    t5 = [isSwiftPending, requestNotification];
    $[6] = isSwiftPending;
    $[7] = requestNotification;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== notificationResponse || $[11] !== setAppModal || $[12] !== setTempDeviceTokenData) {
    t6 = () => {
      const {
        data,
        isSuccess
      } = notificationResponse ?? {};
      if (notificationResponse && !isSuccess) {
        const deniedData = data as unknown as {
          needsSettings?: boolean;
        } | undefined;
        if (deniedData?.needsSettings) {
          setNeedsSettings(true);
          setAppModal({
            type: "permission",
            isOpened: true
          });
        }
        return;
      }
      if (isSuccess && data) {
        if (navigator.userAgent.includes("swift") || navigator.userAgent.includes("ios")) {
          if (data.fcm_token) {
            setTempDeviceTokenData(data);
            setIsSwiftPending(false);
          } else {
            setIsSwiftPending(true);
          }
        } else {
          setTempDeviceTokenData(data);
        }
      }
    };
    t7 = [notificationResponse, setAppModal, setTempDeviceTokenData];
    $[10] = notificationResponse;
    $[11] = setAppModal;
    $[12] = setTempDeviceTokenData;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== closeModal || $[16] !== needsSettings || $[17] !== type) {
    t8 = () => {
      if (needsSettings) {
        setNeedsSettings(false);
        closeModal();
        return;
      }
      if (type !== "permission" && type !== "forceUpdate") {
        closeModal();
      }
    };
    $[15] = closeModal;
    $[16] = needsSettings;
    $[17] = type;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== closeModal || $[20] !== needsSettings || $[21] !== osType || $[22] !== requestNotification || $[23] !== requestSystemSettings) {
    t9 = needsSettings ? <article className="flex flex-col items-center gap-8"><h2 className="text-center font-700 typo-h5">알림이 차단되어 있어요</h2><p className="mb-16 text-center text-Gray-600 typo-body4">기기 설정에서 알림을 허용하면<br />맞춤 정보를 받아볼 수 있어요.{osType !== "ios" ? <><br />설정 화면에서 「알림」을 눌러 켜주세요.</> : null}</p><Button onClick={() => {
        requestSystemSettings();
        setNeedsSettings(false);
        closeModal();
      }}>설정으로 이동</Button><Button theme="sub-text" onClick={() => {
        setNeedsSettings(false);
        closeModal();
      }}>다음에 할래요</Button></article> : <article className="flex h-full max-h-[70vh] flex-col"><h2 className="mb-8 font-700 typo-body1">서비스 이용을 위한<br />권한 접근이 필요해요.</h2><div className="flex flex-1 flex-col gap-20 overflow-y-auto"><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">필수 접근 권한</h3><p className="text-Gray-600 typo-body4">필수적 접근 권한 없음</p></div></section><section className="flex flex-col gap-16 border-b-1 border-Gray-300 pb-20"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">선택적 접근 권한</h3><p className="text-Gray-600 typo-body4">선택적 접근 권한은 해당 기능을 사용할 때 허용이 필요하며, 비허용 시에도 해당 기능 외 서비스 이용이 가능합니다.</p></div><ul className="flex flex-col gap-10 px-16">{[{
              icon: Notification,
              title: "\uC54C\uB9BC(\uC120\uD0DD)",
              description: "\uAC1C\uC778\uBCC4 \uB9DE\uCDA4 \uC815\uBCF4 \uC54C\uB9BC"
            }, {
              icon: Camera,
              title: "\uCE74\uBA54\uB77C(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }, {
              icon: ImgPicker,
              title: "\uC0AC\uC9C4(\uC120\uD0DD)",
              description: "\uB2F5\uB840\uD488 \uD6C4\uAE30, \uBB38\uC758, \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0 \uB4F1\uB85D"
            }].map(_temp2)}</ul></section><section className="flex flex-col gap-16 pb-16"><div className="flex flex-col gap-2"><h3 className="font-600 text-Gray-900 typo-body4">접근 권한 변경 방법</h3><p className="text-Gray-600 typo-body4">휴대폰 설정 {">"} 앱 또는 애플리케이션 관리 {">"} 웰로{" "}{">"} 권한에서 각 권한별 변경 가능합니다.</p></div></section></div><Button className="mt-16" onClick={async () => {
        requestNotification();
        closeModal();
      }}>확인</Button></article>;
    $[19] = closeModal;
    $[20] = needsSettings;
    $[21] = osType;
    $[22] = requestNotification;
    $[23] = requestSystemSettings;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h2 className="text-center font-700 typo-h5">앱을 나가시겠어요?</h2>;
    t11 = <p className="mb-16 text-Gray-600 typo-body4">더이상 뒤로 갈 페이지가 없어요.</p>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t10 = $[25];
    t11 = $[26];
  }
  let t12;
  if ($[27] !== closeModal) {
    t12 = <Button onClick={closeModal}>계속 볼게요</Button>;
    $[27] = closeModal;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== requestExit) {
    t13 = <Button theme="sub-text" onClick={() => requestExit()}>나갈게요</Button>;
    $[29] = requestExit;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t12 || $[32] !== t13) {
    t14 = <article className="flex flex-col items-center gap-8">{t10}{t11}{t12}{t13}</article>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h2 className="text-center font-700 typo-h5">업데이트가 필요해요</h2>;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="mb-16 text-Gray-600 typo-body4">원활한 서비스 이용을 위해<br />최신 버전으로 업데이트해 주세요.</p>;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== osType) {
    t17 = <article className="flex flex-col items-center gap-8">{t15}{t16}<Button onClick={() => {
        window.location.href = getAppStoreUrls(osType === "ios" ? "ios" : "android").schemeUrl;
      }}>업데이트하기</Button></article>;
    $[36] = osType;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t14 || $[39] !== t17 || $[40] !== t9) {
    t18 = {
      permission: t9,
      exit: t14,
      forceUpdate: t17
    };
    $[38] = t14;
    $[39] = t17;
    $[40] = t9;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = t18[type];
  let t20;
  if ($[42] !== isOpened || $[43] !== t19 || $[44] !== t8) {
    t20 = <ResponsiveDialog opened={isOpened} onClose={t8} ariaLabel={"\uC571 \uC548\uB0B4"} drawerType="bottom">{t19}</ResponsiveDialog>;
    $[42] = isOpened;
    $[43] = t19;
    $[44] = t8;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
};
function _temp(state) {
  return [state.appModal, state.setAppModal, state.setTempDeviceTokenData, state.osType];
}
function _temp2(t0, index) {
  const {
    icon: Icon,
    title,
    description
  } = t0;
  return <li key={index} className="flex items-center gap-16"><div className="size-48 rounded-pill bg-Gray-100 flex-center"><Icon alt={title} /></div><div className="flex flex-col gap-2"><h4 className="font-700 text-Gray-900 typo-body4">{title}</h4><p className="text-Gray-600 typo-body4">{description}</p></div></li>;
}